import {
  type DeleteApiAlbumsIdPathParams,
  type PostApiAlbumsMutationRequest,
  type PutApiAlbumsIdMutationRequest,
  type PutApiAlbumsIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import { albumByIdQuery, albumCreate, albumDelete, albumUpdate } from '../api'

// By Id
interface AlbumGateProps {
  id: string
}
export const AlbumGate = createGate<AlbumGateProps>()

sample({
  clock: AlbumGate.open,
  fn: ({ id }: AlbumGateProps) => ({ id }),
  target: albumByIdQuery.start,
})

sample({
  clock: AlbumGate.close,
  target: albumByIdQuery.reset,
})

// Create

export const albumSubmitted = createEvent<PostApiAlbumsMutationRequest>()
sample({
  clock: albumSubmitted,
  fn: (data) => ({ data }),
  target: [albumCreate.start],
})

sample({
  clock: albumCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

export const albumEdited = createEvent<{
  id: PutApiAlbumsIdPathParams['Id']
  data: PutApiAlbumsIdMutationRequest
}>()
sample({
  clock: albumEdited,
  fn: ({ id, data }) => ({ id, data }),
  target: [albumUpdate.start],
})

sample({
  clock: albumUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})
// Delete

export const albumDeleted = createEvent<{
  id: DeleteApiAlbumsIdPathParams['Id']
}>()

sample({
  clock: albumDeleted,
  fn: ({ id }) => ({ id }),
  target: [albumDelete.start],
})

sample({
  clock: albumDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
